import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import RouterLink from 'redux-first-router-link'

import styles from './styles.css'

class Link extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    label: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }

  static defaultProps = {
    className: '',
    children: null,
    label: '',
    href: '',
  }

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  getElement() {
    const { href } = this.props

    if (typeof href === 'string' && href.includes('://')) {
      return 'a'
    }

    // temporary return as there's no `store` within storybook
    return RouterLink
  }

  render() {
    const { children, label, href, ...restProps } = this.props

    const Element = this.getElement()

    if (href) {
      restProps[Element === 'a' ? 'href' : 'to'] = href
    }

    return (
      <Element {...restProps} className={this.getClassName()}>
        {children || label}
      </Element>
    )
  }
}

export default Link



// WEBPACK FOOTER //
// ../source/components/Link/index.js